import { render, staticRenderFns } from "./karpeg.vue?vue&type=template&id=dd296638&"
import script from "./karpeg.vue?vue&type=script&lang=js&"
export * from "./karpeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports